<template>
  <div id="app">
    <app-screen-email-modal v-if="activeModal === 1"></app-screen-email-modal>
    <app-language-list></app-language-list>
    <div class="page-container">
      <transition name="slide" mode="out-in">
        <keep-alive>
          <component :is="appPage"></component>
        </keep-alive>
      </transition>
    </div>
    <app-navigation></app-navigation>
  </div>
</template>

<script>
  import LanguageList from './components/LanguageList';
  import Navigation from './components/Navigation';

  import ScreenSplash from './components/screens/Splash';
  import ScreenLaserUse from './components/screens/LaserUse';
  import ScreenCategory from './components/screens/Category';
  import ScreenApplication from './components/screens/Application';
  import ScreenResult from './components/screens/Result';
  import ScreenEmailModal from './components/screens/EmailModal';

  import { mapGetters } from 'vuex';
  import { mapActions } from 'vuex';

  export default {
    name: 'app',
    computed: {
      ...mapGetters({
        currentLanguage: 'getLanguage',
        appPage: 'navigation/getAppPage',
        activeModal: 'navigation/getActiveModal',
      }),
    },
    methods: {
      ...mapActions({
        setLanguage: 'setLanguage',
        closeModal: 'navigation/closeModal',
      }),
    },
    components: {
      appLanguageList: LanguageList,
      appNavigation: Navigation,
      appScreenSplash: ScreenSplash,
      appScreenLaserUse: ScreenLaserUse,
      appScreenCategory: ScreenCategory,
      appScreenApplication: ScreenApplication,
      appScreenResult: ScreenResult,
      appScreenEmailModal: ScreenEmailModal,
    },
    created() {
      //this.setLanguage(this.currentLanguage);
      if (window.location.hostname.match('.*laserkiezen.*')) {
        this.setLanguage('NL');
      } else if (window.location.hostname.match('.*choisirlaser.*')) {
        this.setLanguage('FR');
      } else if (window.location.hostname.match('.*laserauswahlen.*')) {
        this.setLanguage('DE');
      } else if (window.location.hostname.match('.*xn--vlglaser-j0a.*')) {
        this.setLanguage('DA');
      } else if (window.location.hostname.match('.*valitselaser.*')) {
        this.setLanguage('FI');
      } else if (window.location.hostname.match('.*velduleysir.eu.*')) {
        this.setLanguage('IS');
      } else if (window.location.hostname.match('.*velglaser.*')) {
        this.setLanguage('NO');
      } else if (window.location.hostname.match('.*trovalaser.*')) {
        this.setLanguage('IT');
      } else {
        this.setLanguage('EN');
      }
    }
  }
</script>

<style>
  .slide-enter {
    opacity: 0;
  }

  .slide-enter-active {
    animation: slide-in ease-out .2s;
    transition: opacity .2s;
  }

  .slide-leave {

  }

  .slide-leave-active {
    animation: slide-out ease-in .2s forwards;
    transition: opacity.2s;
    opacity: 0;
  }

  @keyframes slide-in {
    from {
      transform: translateX(500px);
    }
    to {
      transform: translateX(0);
    }
  }

  @keyframes slide-out {
    from {
      transform: translateX(0);
    }
    to {
      transform: translateX(-500px);
    }
  }


</style>


// WEBPACK FOOTER //
// src/App.vue